













import Vue, { PropType } from 'vue'
import { sendBookingVoucher } from '~/api/RentalCar'
import IconButton from '~/components/IconButton.vue'
import { CarBooking } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { IconButton },
  props: {
    item: { type: Object as PropType<CarBooking>, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      try {
        this.loading = true
        await sendBookingVoucher(this.item.uuid)
        this.item.pdf_sent = true
      } finally {
        this.loading = false
      }
    },
  },
})
